import { render, staticRenderFns } from "./AutomaticResponseMailboxModal.vue?vue&type=template&id=003b24b4&scoped=true"
import script from "./AutomaticResponseMailboxModal.vue?vue&type=script&lang=js"
export * from "./AutomaticResponseMailboxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b24b4",
  null
  
)

export default component.exports